import { ReactComponent as QuestionmarkInfoIcon } from '@assets/svg/question-info-tip.svg';
import { StyledLabel } from './Label.styles';

interface NoTipLabel {
  tip?: never;
  'data-for'?: never;
}
interface TipLabel {
  tip: string;
  'data-for': string;
}

// Enforce passing both tip and tooltip id
type LabelProps = NoTipLabel | TipLabel;

type DecoratedLabelProps = React.PropsWithChildren<LabelProps> &
  React.ComponentProps<typeof StyledLabel> &
  React.HTMLProps<typeof StyledLabel>;

/** Label for inputs with optional info that renders an icon on the right with tooltip.
 *
 * # Note
 * Must pass data-for (tooltip id) alongside tip for react-tooltip.
 */
export function Label(props: DecoratedLabelProps) {
  const { children, tip = '', ...rest } = props;
  return (
    <StyledLabel {...rest} data-tip={tip}>
      <span>{children}</span>
      {tip && <QuestionmarkInfoIcon />}
    </StyledLabel>
  );
}
